var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.99,.12l-62.44,46.18,11.64-27.22L151.99,.12Z",
    fill: "#e17726",
    stroke: "#e17726",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01,.12l61.87,46.56-11.07-27.55L8.01,.12Zm121.5,107.04l-16.63,25.37,35.59,9.79,10.17-34.59s-29.13-.57-29.13-.57ZM1.41,107.73l10.12,34.59,35.49-9.79-16.54-25.37s-29.08,.57-29.08,.57Z",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.12,64.31l-9.88,14.92,35.16,1.62-1.14-37.86-24.14,21.38v-.05Zm69.75,.05l-24.52-21.85-.81,38.34,35.16-1.62s-9.84-14.87-9.84-14.87ZM47.02,132.53l21.33-10.26-18.34-14.25-2.99,24.51Zm44.67-10.31l21.19,10.31-2.85-24.56s-18.34,14.25-18.34,14.25Z",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.88,132.53l-21.19-10.26,1.71,13.78-.19,5.84,19.67-9.36Zm-65.86,0l19.77,9.36-.14-5.84,1.71-13.78-21.33,10.26Z",
    fill: "#d5bfb2",
    stroke: "#d5bfb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.12,98.85l-17.58-5.13,12.45-5.7,5.18,10.83h-.05Zm25.71,0l5.23-10.88,12.5,5.7-17.72,5.23v-.05Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.02,132.53l3.09-25.37-19.62,.57s16.54,24.8,16.54,24.8Zm62.86-25.37l2.99,25.37,16.63-24.8-19.62-.57Zm14.87-27.93l-35.16,1.62,3.23,18.05,5.23-10.93,12.5,5.7s14.21-14.44,14.21-14.44Zm-75.22,14.49l12.45-5.7,5.18,10.83,3.28-18.05-35.16-1.57,14.25,14.49Z",
    fill: "#cc6228",
    stroke: "#cc6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.29,79.23l14.73,28.74-.48-14.25s-14.25-14.49-14.25-14.49Zm75.27,14.49l-.57,14.25,14.73-28.74s-14.16,14.49-14.16,14.49Zm-40.1-12.87l-3.33,18.05,4.18,21.28,.95-28.08-1.81-11.26Zm19.1,0l-1.71,11.21,.86,28.12,4.13-21.33-3.28-18.05v.05Z",
    fill: "#e27525",
    stroke: "#e27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.83,98.85l-4.13,21.33,2.99,2.09,18.29-14.25,.57-14.3-17.72,5.13Zm-43.29-5.13l.48,14.25,18.34,14.25,2.95-2.04-4.13-21.33-17.68-5.13h.05Z",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.26,141.89l.14-5.84-1.62-1.33h-23.57l-1.57,1.33,.14,5.84-19.77-9.36,6.94,5.7,14.02,9.64h24l14.06-9.69,6.84-5.65-19.67,9.36h.05Z",
    fill: "#c0ac9d",
    stroke: "#c0ac9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.69,122.22l-2.99-2.04h-17.39l-2.95,2.09-1.71,13.78,1.57-1.33h23.57l1.62,1.33-1.71-13.78v-.05Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.65,49.3l5.23-25.42L151.99,.12l-60.35,44.66,23.24,19.53,32.79,9.55,7.22-8.41-3.14-2.28,4.99-4.56-3.8-2.95,4.99-3.8-3.33-2.57h.05ZM.12,23.83l5.32,25.46-3.42,2.52,5.08,3.8-3.8,2.99,4.94,4.56-3.14,2.28,7.22,8.41,32.79-9.5,23.24-19.62L8.01,.12,.12,23.83Z",
    fill: "#763e1a",
    stroke: "#763e1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.66,73.86l-32.79-9.5,9.88,14.87-14.73,28.74,19.48-.24h29.13l-10.98-33.87Zm-102.54-9.55l-32.79,9.55L1.41,107.73H30.54l19.48,.24-14.73-28.74,9.88-14.92h-.05Zm44.43,16.53l2.14-36.11,9.5-25.65H58.81l9.5,25.65,2.14,36.11,.81,11.31v28.03h17.44l.1-28.03s.76-11.31,.76-11.31Z",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.440d0913e366660fd0df9fc9435deb9c.svg";
export { ForwardRef as ReactComponent };